import { FC, useState } from "react";
import { PulseLoader } from "react-spinners";
import "./style.css";

interface StatePorps {
  message: string;
  visible: boolean;
  onDismissed: (dismissed: boolean) => void;
  loading: boolean;
}

const SuggestionCard: FC<StatePorps> = ({
  message,
  visible = false,
  onDismissed,
  loading,
}) => {
  const [dismissed, setDismissed] = useState(false);

  const handleClose = () => {
    onDismissed(false);
    setTimeout(() => setDismissed(true), 300); // wait for fade-out
  };

  if (dismissed) return null;

  return (
    <div
      style={{ width: "100%" }}
      className={`suggestion-card ${visible ? "show" : "hide"}`}
    >
      <div className="card-header">
        <div className="left">
          <span className="bulb-icon">💡</span>
          <span className="ai-label">AI Suggestion</span>
        </div>
        <button className="close-button" onClick={handleClose}>
          &times;
        </button>
      </div>
      {loading && (
        <div
          style={{
            height: "50px",
            textAlign: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              width: "100%",

              alignItems: "center",
            }}
          >
            <PulseLoader size={10} color="#4a4a4a" />
          </div>
        </div>
      )}
      {!loading && (
        <>
          <div className="card-body">
            <div dangerouslySetInnerHTML={{ __html: message }} />
          </div>
          <div className="card-footer">
            <span>Generated by AI Assistant</span>
          </div>
        </>
      )}
    </div>
  );
};

export default SuggestionCard;
